import React from 'react';

const STATUS_COLORS = {
  Active: '#00B374',
  Pending: '#E6A832',
  Waiting: '#E6A832',
  Void: '#CC3333',
  Legal: '#CC3333',
  Expired: '#E6A832',
  Resigned: '#CC3333',
  Terminated: '#CC3333',
  Vacated: '#CC3333',
  Cancel: '#CC3333',
};

const MemberInfoCard = ({ user, partner }) => {
  if (!user) return null;

  return (
    <div
      style={{
        padding: 20,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        borderRadius: 12,
        color: '#fff',
        height: '100%',
      }}
    >
      {/* Profile + Name + Badges row */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        <div
          style={{ display: 'flex', alignItems: 'center', gap: 16, flex: 1 }}
        >
          {user.imageUrl ? (
            <img
              src={user.imageUrl}
              alt="profile"
              style={{
                width: 56,
                height: 56,
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 24,
                fontWeight: 'bold',
              }}
            >
              {user.FirstNameTh?.charAt(0) || '?'}
            </div>
          )}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 'bold' }}>
              {user.FirstNameTh} {user.SurNameTh}
            </div>
            <div
              style={{
                fontSize: 12,
                opacity: 0.8,
                marginTop: 2,
                marginBottom: 6,
              }}
            >
              {user.HonorCode}
            </div>
            <div
              style={{
                display: 'flex',
                gap: 8,
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              {user.MemberType && (
                <span
                  style={{
                    padding: '4px 12px',
                    borderRadius: 12,
                    background: 'rgba(255,255,255,0.2)',
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                >
                  {user.MemberType === 'Distributor' && 'นักธุรกิจ'}
                  {user.MemberType === 'Member' && 'VIP Member'}
                </span>
              )}
              {user.Status && (
                <span
                  style={{
                    padding: '4px 12px',
                    borderRadius: 12,
                    background: (STATUS_COLORS[user.Status] || '#999') + '88',
                    color: '#fff',
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                >
                  {user.StatusText || user.Status}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div
        style={{
          height: 1,
          background: 'rgba(255,255,255,0.2)',
          margin: '12px 0',
        }}
      />

      {/* Partner Info */}
      {partner && (
        <div
          style={{
            padding: 12,
            background: 'rgba(255,255,255,0.1)',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            marginBottom: 12,
          }}
        >
          {partner.imageUrl ? (
            <img
              src={partner.imageUrl}
              alt="partner"
              style={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 14,
                fontWeight: 'bold',
              }}
            >
              {partner.FirstNameTh?.charAt(0) || '?'}
            </div>
          )}
          <div>
            <div style={{ fontSize: 11, opacity: 0.7 }}>รหัสร่วม</div>
            <div style={{ fontSize: 14, fontWeight: 500 }}>
              {partner.FirstNameTh} {partner.SurNameTh}
            </div>
          </div>
        </div>
      )}
      {partner && (
        <div
          style={{
            padding: 12,
            background: 'rgba(255,255,255,0.1)',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
          }}
        >
          <div>
            <div style={{ fontSize: 11, opacity: 0.7 }}>ทีม</div>
            <div style={{ fontSize: 14, fontWeight: 500 }}>{user.TeamName}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MemberInfoCard;
